module.exports = __webpack_public_path__ + "img/not-found-icon.91cf4e27.svg";